import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import {
  Backdrop,
  Button,
  Divider,
  Drawer,
  DropdownMenu,
  FormFieldSet,
  InfoText,
  InfoTextTwo,
  LogoLoader,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
  Tag,
  TimeSheet,
  useFormHandler,
} from "../../../../components";
import useDropdownData from "../../../../hooks/useDropdownData";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import dayjs from "dayjs";
import {
  addTimesheetStart,
  clearTimesheetData,
  getTimesheetOneStart,
  updateTimesheetStart,
} from "../../../../redux/slices/timesheets/timsheetSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  clearPlacementsData,
  getPlacementByUiidStart,
} from "../../../../redux/slices/placements/placementsSlice";
import { dateFormator, getEmployeeId } from "../../../../utils";
import { getEmployeeName } from "../../../../utils/getDisplays";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import { useNavigate } from "react-router-dom";
import {
  invoiceFrequencyTypeOptions,
  status,
} from "../../../../assets/data/projectData";
import { formatWords2 } from "../../../../utils/stringUtils";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";
import { exactUTCDate } from "../../../../utils/dateFormator";

const SubmitTimesheet = ({ handleBack }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const timesheetDataFromDb =
    useSelector((state) => state.timesheet.currentTimesheet.details) || [];
  const uploadError =
    useSelector((state) => state?.fileUpload?.uploadStatus) || "";
  const timesheetHasError =
    useSelector((state) => state.timesheet.error) || null;
  console.log("timesheetHasError",timesheetHasError)
  const containerRef = useRef(null);
  const [counter, setCounter] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [hasTimesheet, setHasTimesheet] = useState(true);
  const [timesheetData, setTimesheetData] = useState([]);
  console.log("timesheetData", timesheetData);
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { data: currentPlacementData = [] } =
    useSelector((state) => state.placement.placements) || [];
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        employee: "",
        placement: "",
        // fromDate: "",
        // toDate: "",
        fromToDate: "",
        attachments: [],
      },
      {
        employee: { type: "select", required: true },
        placement: { type: "select", required: true },
        // fromToDate: { type: "datepickerRange", required: true },
        attachments: {
          type: "file",
          // required: true,
        },
      },
    );
  const [dates, setDates] = useState({
    from: "",
    to: "",
  });
  
  useEffect(() => {
    if (timesheetHasError || uploadError  === "error") {
      setIsSaving(false);
    }
  },[timesheetHasError])
  
  useEffect(() => {
    setDates({
      from: formData?.fromToDate?.from,
      to: formData?.fromToDate?.to,
    });
    if (
      formData?.fromToDate?.from &&
      formData?.fromToDate?.to &&
      formData?.employee?.value
    ) {
      (async () => {
        let result = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.TIMESHEETS.GET_BY_UIID,
          params: {
            coll: "Timesheet",
            fil: JSON.stringify({
              employeeId: { type: "NONE", value: formData?.employee?.value },
              placementId: {
                type: "NONE",
                value: parseInt(formData?.placement?.split(":")[0]),
              },
              period: {
                type: "RANGE",
                value: {
                  from: formData?.fromToDate?.from,
                  to: formData?.fromToDate?.to,
                },
              },
            }),
            ret: "uiid employeeId placementId period",
          },
        });
        if (result?.success && result?.data?.data?.uiid) {
          setHasTimesheet(true);
          showToast(
            "Timesheet already exists for the selected date range",
            "info",
            5000,
          );
        } else setHasTimesheet(false);
      })();
    }
  }, [formData?.fromToDate?.from, formData?.fromToDate?.to]);
  
  const {
    data: allSelectEmployeeListOptions,
    searchValue: allSelectEmployeeSearch,
    handleSearch: handleSelectEmployeeSearch,
    resetSearch: resetAllSelectEmployeeSearch,
    handleScroll: handleAllSelectEmployeeScroll,
  } = useDropdownData("employeesSorted", 10, {}, {});
  const {
    data: allSelectPlacementListOptions,
    searchValue: allSelectPlacementSearch,
    handleSearch: handleSelectPlacementSearch,
    resetSearch: resetAllSelectPlacementSearch,
    handleScroll: handleAllSelectPlacementScroll,
  } = useDropdownData(
    "placementsForTimesheetsAdd",
    10,
    {},
    {
      employeeId: formData?.employee?.value,
      // entityId: clientProfileUiid,
      // entityType: "Client",
      // add filter here for a specifuc delegators placements only
    },
  );
  const [arrayOfApprovers, setArrayOfApprovers] = useState([]);
  // const [clientDetails, setClientDetails] = useState(false);
  const [employeeManagers, setEmployeeManagers] = useState({
    finance: "",
    hr: "",
    reportingManager: "",
  });
  const [datesOfPlacement, setDatesOfPlacement] = useState({
    startDate: "",
    endDate: "",
  });
  const employeeId = useMemo(
    () =>
      currentPlacementData?.employeeId?.uiid
        ? getEmployeeId(
            currentPlacementData?.employeeId?.uiid,
            currentPlacementData?.employeeId?.employmentType,
          )
        : undefined,
    [currentPlacementData],
  );
  useEffect(() => {
    if (formData?.placement) {
      const placementId = formData?.placement?.split(":")[0];
      if (placementId) {
        dispatch(
          getPlacementByUiidStart({
            fil: {
              uiid: { type: "NONE", value: placementId },
            },
            ref: "Client EmpWithDelegator",
            // incl: "businessName",
          }),
        );
      }
    }
    return () => {
      dispatch(clearTimesheetData());
      dispatch(clearPlacementsData());
    };
  }, [formData?.placement]);
  useEffect(() => {
    if (!currentPlacementData?.uiid) return;

    const {
      timesheetDetails = {},
      employeeId = {},
      jobInfo = {},
    } = currentPlacementData;

    const fetchAll = async () => {
      const approvers = timesheetDetails.approvers || [];
      const managers = employeeId.managers || {};

      const approverNames = await Promise.all(
        approvers.map((a) => getEmployeeName(a.id)),
      );

      const [finance, hr, reportingManager] = await Promise.all([
        managers.finance ? getEmployeeName(managers.finance) : "",
        managers.HR ? getEmployeeName(managers.HR) : "",
        managers.reportingManager
          ? getEmployeeName(managers.reportingManager)
          : "",
      ]);

      const newManagerObj = { finance, hr, reportingManager };
      const newDateObj = {
        startDate: jobInfo.startDate || "",
        endDate: jobInfo.endDate || "",
      };

      const isSameManager =
        JSON.stringify(employeeManagers) === JSON.stringify(newManagerObj);
      const isSameDate =
        JSON.stringify(datesOfPlacement) === JSON.stringify(newDateObj);

      if (!isSameManager) setEmployeeManagers(newManagerObj);
      if (!isSameDate) setDatesOfPlacement(newDateObj);
      if (approverNames.length) setArrayOfApprovers(approverNames);
    };

    fetchAll();
  }, [currentPlacementData?.uiid]);
  const handleExposeState = (state) => {
    setTimesheetData(state);
  };
  useEffect(() => {
    if (timesheetDataFromDb?.uiid) {
      setTimesheetData(timesheetDataFromDb);
    }
  }, [timesheetDataFromDb]);
  //add filters here 👆 for a specific delegators employee to see in pop up
  const timeToDecimal = (timeStr) => {
    if (!timeStr) return 0;
    const [hours, minutes] = timeStr.split(":").map(Number);
    return Number((hours + minutes / 60).toFixed(2));
  };
  function parseDate(dateStr, separator = "/", format = "YYMMDD") {
    const dateArray = dateStr.split(separator).map(Number);
    let yyyy, mm, dd;
    switch (format) {
      case "YYMMDD":
        [yyyy, mm, dd] = dateArray;
        break;
      case "MMDDYY":
        [mm, dd, yyyy] = dateArray;
        break;
      default:
        throw new Error(`Unsupported date format: ${format}`);
    }
    return new Date(Date.UTC(yyyy, mm - 1, dd));
  }

  const handleSave = async (statusType) => {
    try {
      const userApprovalFlowSettings =
        currentPlacementData?.employeeId?.approvalFlow || {};
      console.log({ userApprovalFlowSettings });
      const isUserDelegator =
        userApprovalFlowSettings?.delegator?.userId === loginUserUiid;
      if (!isUserDelegator) {
        showToast("You are not a Delegator for this Employee", "error", 5000);
        return;
        // }
      }
      setIsSaving(true);
      const dates = {
        from: parseDate(
          dayjs(formData?.fromToDate?.from).format("MM/DD/YYYY"),
          "/",
          "MMDDYY",
        ),
        to: parseDate(
          dayjs(formData?.fromToDate?.to).format("MM/DD/YYYY"),
          "/",
          "MMDDYY",
        ),
        // from: dayjs(formData?.fromToDate?.from).format("MM/DD/YYYY"),
        // to: dayjs(formData.fromToDate?.to).format("MM/DD/YYYY"),
      };
      // return;
      // const TimesheetStatus = {
      //   1: "Draft",
      //   2: "Submitted",
      //   3: "Approved",
      //   4: "Rejected",
      //   5: "Job Inactive",
      //   6: "Invoiced",
      // };
      const isValid = validateAllFields();
      if (!statusType) {
        showToast("Something went wrong", "error");
        return;
      }
      if (isValid) {
        if (formData?.fromToDate === "") {
          showToast("Please select from date and to date", "error");
          return;
        }
        try {
          let createdPayload;
          if (timesheetDataFromDb?.uiid) {
            //for update payload
            createdPayload = [
              {
                type: "SET",
                value: {
                  status:
                    statusType === 1 ? 1 : statusType === 2 || 3 ? 2 : null,
                  comment: formData?.comment,
                  dailyEntries: timesheetData.map((item) => ({
                    // date: dayjs(item.payClassification, "YYYYMMDD").toISOString(),
                    date: dayjs
                      .utc(item.payClassification, "YYYYMMDD")
                      .format("YYYYMMDD"),
                    st: timeToDecimal(item.standardTime),
                    th: timeToDecimal(item.totalHours),
                    tbh: timeToDecimal(item.totalBillableHours),
                  })),
                },
              },
              {
                type: "PUSH",
                value: {
                  ...(statusType !== 1 && {
                    auditHistory: [
                      {
                        timestamp: new Date(),
                        status:
                          statusType === 1
                            ? 1
                            : statusType === 2 || 3
                              ? 2
                              : null,
                        st: timesheetData.reduce(
                          (acc, item) => acc + timeToDecimal(item.standardTime),
                          0,
                        ),
                        tbh: timesheetData.reduce(
                          (acc, item) =>
                            acc + timeToDecimal(item.totalBillableHours),
                          0,
                        ),
                        // updatedBy: loginUserData?.employeeId,
                        updatedBy: loginUserUiid,
                      },
                    ],
                  }),
                },
              },
            ];
          } else {
            // if(attachments?.length > 0) {
            //   dispa
            // }
            //for create payload
            createdPayload = {
              comments: formData?.comment,
              employeeId: formData?.employee?.value,
              placementId: formData?.placement?.split(":")[0] || "",
              clientId: formData?.placement?.split(":")[1] || "",
              addedBy: loginUserUiid,
              status: statusType === 1 ? 1 : statusType === 2 || 3 ? 2 : null,
              period: {
                month:
                  dayjs(formData?.fromToDate?.from).format("MM") ||
                  dayjs(formData?.fromToDate).format("MM"),
                year:
                  dayjs(formData?.fromToDate?.from).format("YYYY") ||
                  dayjs(formData?.fromToDate).format("YYYY"),
                from: dates.from,
                to: dates.to,
              },
              dailyEntries: timesheetData.map((item) => ({
                // date: dayjs(item.payClassification, "YYYYMMDD").toISOString(),
                // date: dayjs
                //   .utc(item.payClassification, "YYYYMMDD")
                //   .format("YYYYMMDD"),
                //testing
                date: dayjs(item.payClassification, "YYYYMMDD").format(
                  "YYYYMMDD",
                ),
                st: timeToDecimal(item.standardTime),
                th: timeToDecimal(item.totalHours),
                tbh: timeToDecimal(item.totalBillableHours),
              })),
              amounts: {
                total:
                  currentPlacementData?.payments[
                    currentPlacementData?.payments.length - 1
                  ]?.payRate?.payType === 1
                    ? timesheetData?.reduce(
                        (acc, item) => acc + timeToDecimal(item.standardTime),
                        0,
                      ) *
                      (currentPlacementData?.payments[
                        currentPlacementData?.payments.length - 1
                      ]?.payRate?.payRatePerHour || 0)
                    : currentPlacementData?.payments[
                        currentPlacementData?.payments.length - 1
                      ]?.payRate?.payRatePerHour,
              },
              periodCycle:
                currentPlacementData?.timesheetDetails?.submissionSettings
                  ?.cycles,
              // auditHistory logging pending
              auditHistory: [
                {
                  timestamp: new Date(),
                  status:
                    statusType === 1 ? 1 : statusType === 2 || 3 ? 2 : null,
                  st: timesheetData.reduce(
                    (acc, item) => acc + timeToDecimal(item.standardTime),
                    0,
                  ),
                  tbh: timesheetData.reduce(
                    (acc, item) => acc + timeToDecimal(item.totalBillableHours),
                    0,
                  ),
                  // updatedBy: loginUserData?.employeeId,
                  updatedBy: loginUserUiid,
                },
              ],
              //add timesheet
              onSuccess: async (resData) => {
                const timesheetId = resData?.data?.timesheetId;
                if (formData?.attachments?.length > 0) {
                  dispatch(
                    uploadStart({
                      uploadType: "multiple",
                      field: "doc",
                      uiid: timesheetId,
                      entity: "timesheets",
                      category: "timesheets",
                      coll: "Timesheet",
                      doc: formData?.attachments,
                      addedBy: loginUserUiid,
                      onSuccess: async (fileData) => {
                        setIsSaving(false);
                        const payload = [
                          {
                            type: "PUSH",
                            value: {
                              attachments: fileData.map((file) => file.key),
                            },
                          },
                        ];
                        dispatch(
                          updateTimesheetStart({
                            coll: "Timesheet",
                            uiid: timesheetId,
                            payload: payload,
                            supressToast: true,
                            onSuccess: async () => {
                              setIsSaving(false);
                              handleBack();
                            },
                          }),
                        );
                      },
                    }),
                  );
                } else {
                  if (statusType == 1 || statusType == 2) {
                    handleBack();
                    setIsSaving(false);
                  }
                  dispatch(
                    getTimesheetOneStart({
                      filters: {
                        uiid: {
                          type: "NONE",
                          value: timesheetId,
                        },
                      },
                    }),
                  );
                }
              },
            };
          }
          //api work
          if (timesheetDataFromDb?.uiid) {
            //updating existing timesheet
            dispatch(
              updateTimesheetStart({
                coll: "Timesheet",
                uiid: timesheetDataFromDb.uiid,
                payload: createdPayload,
                onSuccess: async (resData) => {
                  if (formData?.attachments?.length > 0) {
                    dispatch(
                      uploadStart({
                        uploadType: "multiple",
                        field: "doc",
                        uiid: timesheetDataFromDb.uiid,
                        entity: "timesheets",
                        category: "timesheet",
                        coll: "Timesheet",
                        doc: formData?.attachments,
                        onSuccess: async (fileData) => {
                          const payload = [
                            {
                              type: "PUSH",
                              value: {
                                attachments: fileData.map((file) => file.key),
                              },
                            },
                          ];
                          dispatch(
                            updateTimesheetStart({
                              coll: "Timesheet",
                              uiid: timesheetDataFromDb.uiid,
                              payload: payload,
                              onSuccess: async () => {
                                  handleBack();
                              },
                            }),
                          );
                        },
                      }),
                    );
                  } else {
                    if (statusType == 1 || statusType == 2) {
                      handleBack();
                    }
                    dispatch(
                      getTimesheetOneStart({
                        filters: {
                          uiid: {
                            type: "NONE",
                            value: resData?.data?.doc?.uiid,
                          },
                        },
                      }),
                    );
                  }
                },
              }),
            );
          } else {
            //create new timesheet if no timesheet found
            dispatch(addTimesheetStart(createdPayload));
          }
        } catch (error) {
          showToast("Failed to add timesheet", "error", 3000);
          console.error("error", error);
        }
      } else {
        showToast("Please fill all the required fields", "error", 3000);
        console.error("error:", errors);
      }
    } catch (error) {
      console.error("error in timehseet save", error);
    } finally {
      // setIsSaving(false);
    }
  };
  const handleClickReset = async () => {
    try {
      await handleSave(3);
      setViewDetails(false);
      setTimesheetData([]);
      dispatch(clearPlacementsData());
      dispatch(clearTimesheetData());
      setFormData({
        employee: "",
        placement: "",
        fromToDate: {
          from: null,
          to: null,
        },
        attachments: null,
      });
      // handleChange("fromToDate", "");
      // handleChange("attachments", []);
    } catch (error) {
      console.error("error in timehseet save", error);
    }
  };
  const [employeeName, setEmployeeName] = useState("");
  useEffect(() => {
    const fetchEmployeeByUiid = async () => {
      if (formData.employee?.value) {
        const name = await getEmployeeName(formData?.employee?.value);
        setEmployeeName(name);
      }
    };
    fetchEmployeeByUiid();
  }, [formData.employee]);

  // auto select timetranges for month
  // useEffect(() => {
  //   // if (true) {
  //   if (currentPlacementData?.invoices?.frequency === 4) {
  //     if (formData?.fromToDate?.from && !formData?.fromToDate?.to) {
  //       handleChange("fromToDate", {
  //         from: formData.fromToDate.from,
  //         to: dayjs(formData.fromToDate.from)
  //           .endOf("month")
  //           .format("YYYY-MM-DD"),
  //       });
  //     }
  //   }
  // }, [formData?.fromToDate?.from, currentPlacementData]);
  return (
    <div>
      <PageHeader
        className="mt-3 flex-wrap items-start! md:justify-between md:items-center"
        Section={
          <div className="flex gap-2">
            <Button
              // type="icon"
              variant="text"
              icon="arrow_left_alt"
              color="black"
              title={"Add Timesheet"}
              onClick={handleBack}
              className="pl-0!"
            />
            {/* <PageTitle title={"Add Timesheet"} tag="p" /> */}
            {formData.employee && (
              <Tag
                // title={formData.employee}
                title={`${formatWords2(formData.employee?.label)}`}
                variant="outlined"
                color="warning"
                className=" !text-neutrals !py-1 whitespace-nowrap"
              />
            )}
          </div>
        }
        RightSection={
          <div className="flex gap-2">
            <Button
              size="sm"
              title={"Save"}
              onClick={() => handleSave(1)}
              disabled={hasTimesheet || isSaving}
            />
            <DropdownMenu
              MenuSection={
                <div className="p-1 ">
                  <Button
                    color="dark"
                    title={"Submit"}
                    variant="text"
                    size="sm"
                    className="w-full text-left"
                    onClick={() => handleSave(2)}
                    disabled={hasTimesheet || isSaving}
                  />
                  <Button
                    color="dark"
                    title={"Submit and New"}
                    variant="text"
                    size="sm"
                    className="w-full text-left"
                    onClick={handleClickReset}
                    disabled={hasTimesheet || isSaving}
                  />
                </div>
              }
            >
              <Button
                color="primary"
                size="sm"
                title={"Submit"}
                icon="keyboard_arrow_down"
                iconPosition="after"
                disabled={hasTimesheet || isSaving}
              />
            </DropdownMenu>
            <Button
              color="primary"
              size="sm"
              title={"Cancel"}
              variant="outlined"
              onClick={handleBack}
            />

            <DropdownMenu
              MenuSection={
                <div className="p-1 ">
                  <Button
                    color="dark"
                    title={"Update Work Location"}
                    variant="text"
                    size="sm"
                    className="w-full text-left"
                  />
                  <Button
                    color="dark"
                    title={"Update Reporting Manager"}
                    variant="text"
                    size="sm"
                    className="w-full text-left"
                  />
                </div>
              }
            >
              <Button
                color="primary"
                size="sm"
                title={"More Actions"}
                icon="keyboard_arrow_down"
                iconPosition="after"
                variant="outlined"
              />
            </DropdownMenu>
          </div>
        }
      />
      <div className="mt-3 p-6 border-[1px] border-neutrals-50 rounded">
        <div className="grid grid-cols-[repeat(2,1fr)_120px] lg:grid-cols-3 max-w-7xl gap-x-6 gap-y-4">
          <div className="col-span-1 ">
            {/* from shiva */}
            {/* <FormFieldSet
              type="select"
              title="Submit Timesheets for"
              placeholder="Select Employee"
              value={formData.employee}
              onChange={(value) => handleChange("employee", value)}
              error={errors.employee}
            /> */}

            <FormFieldSet
              type="employeesSorted"
              title="Submit Timesheets for"
              placeholder="Select Employee"
              value={formData.employee?.label}
              onChange={(value) => handleChange("employee", value)}
              // options={allSelectEmployeeListOptions}
              keyname="employeesSorted"
              showSearch
              // searchValue={allSelectEmployeeSearch}
              // onClose={resetAllSelectEmployeeSearch}
              // refData={containerRef}
              // onSearch={handleSelectEmployeeSearch}
              // handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
              error={errors.employee}
            />
          </div>
          <div>
            {/* {formData.employee ? (*/}
            <FormFieldSet
              disabled={!formData.employee}
              type="select"
              // type="placementsForTimesheetsAdd"
              title="Select Placement"
              placeholder="Select Placement"
              // value={formData.placement}
              value={formData.placement?.label}
              onChange={(value) => handleChange("placement", value)}
              options={allSelectPlacementListOptions}
              keyname="placementsForTimesheetsAdd"
              showSearch
              searchValue={allSelectPlacementSearch}
              onClose={resetAllSelectPlacementSearch}
              refData={containerRef}
              onSearch={handleSelectPlacementSearch}
              handleScroll={() => handleAllSelectPlacementScroll(containerRef)}
              error={errors.placement}
            />
            {/* ) : (
              <div className="flex flex-col">
                <p className="body-two">Select Placement</p>
                <p></p>
              </div>
            )}*/}
          </div>
          <div className="flex-1 flex items-end">
            {formData.employee && formData.placement && (
              <Button
                title={"View Details"}
                onClick={() => setViewDetails(true)}
              />
            )}
          </div>
          {/* <div className="flex gap-3">
            <div className="flex-1">
              <FormFieldSet
                type="datepicker"
                title="Select FromDate "
                placeholder="Select From Date"
                value={formData.fromDate}
                onChange={(value) => handleChange("fromDate", value)}
                error={errors.fromDate}
              />
            </div>
            <div className="flex-1">
              <FormFieldSet
                type="datepicker"
                title="Select ToDate"
                placeholder="Select To Date"
                value={formData.toDate}
                onChange={(val) => handleChange("toDate", val)}
                error={errors.toDate}
              />
            </div>
          </div> */}
          <div>
            <FormFieldSet
              // type="datepickerRange"
              type={
                currentPlacementData?.timesheetDetails?.submissionSettings
                  ?.cycles == 1
                  ? "datepicker"
                  : "datepickerRange"
              }
              title="Choose Date"
              placeholder={
                currentPlacementData?.timesheetDetails?.submissionSettings
                  ?.cycles == 1
                  ? "Select Date"
                  : "Select From and To Date"
              }
              value={formData?.fromToDate}
              onChange={(val) => handleChange("fromToDate", val)}
              disabled={formData.placement ? false : true}
              showDropdown={false}
            />
          </div>
          <div>
            <FormFieldSet
              type="file"
              title="Attachment"
              placeholder="ChooseFile"
              value={formData?.attachments}
              onChange={(value) => handleChange("attachments", value)}
              error={errors.attachments}
              multiple
              disabled={timesheetDataFromDb?.uiid ? true : false}
            />
            {/* <FormFieldSet
                      type="file"
                      title="Attachment"
                      placeholder="No file Chosen"
                      onChange={(files) => handleChange("attachment", files)}
                      value={formData.attachment}
                      error={errors.attachment}
                      disabled={!isEditable}
                    /> */}
          </div>
          <div className="col-span-3 lg:col-span-1">
            {((formData?.fromToDate?.from && formData?.fromToDate?.to) ||
              formData?.fromToDate) && (
              <FormFieldSet
                type="textArea"
                title="Comments"
                placeholder="Enter Comments"
                value={formData.comments}
                onChange={(value) => handleChange("comments", value)}
                error={errors.comments}
              />
            )}
          </div>
          {console.log("formData", formData)}
        </div>
        {!hasTimesheet &&
          (formData?.fromToDate?.from ||
            formData?.fromToDate?.to ||
            currentPlacementData?.timesheetDetails?.submissionSettings
              ?.cycles === 1) && (
            <div className="my-3">
              {(() => {
                console.log("logs execcuredddd");
              })()}
              <div className="my-3">
                {(() => {
                  const start =
                    formData?.fromToDate?.from || formData?.fromToDate;
                  const end = formData?.fromToDate?.to || formData?.fromToDate;

                  const startDate = dayjs(start).utc().format();
                  const endDate = dayjs(end).utc().format();
                  console.log("submit timesheet", start, end);
                  console.log(
                    " after dayjs submit timesheet",
                    startDate,
                    endDate,
                  );
                  // if (!startDate.isValid() || !endDate.isValid()) return null;

                  return (
                    <TimeSheet
                      showButtons={false}
                      startDate={startDate}
                      endDate={endDate}
                      exposeState={handleExposeState}
                      submitTimesheet={true}
                    />
                  );
                })()}
              </div>
            </div>
          )}
        <Drawer
          isOpen={viewDetails}
          onClose={() => setViewDetails(false)}
          position="right"
          width="w-[40%]"
          title="Placement Information"
          closeOnOutsideClick
        >
          <div>
            <div className="grid grid-cols-2 gap-y-6">
              {/* <InfoText title={"CLIENT"} size="sm" value={"ShubhaMinds, LLC"} /> */}
              {/* <InfoText title={"CLIENT"} size="sm" value={"ShubhaMinds, LLC"} /> */}
              <InfoText
                title={"CLIENT"}
                size="sm"
                value={
                  currentPlacementData?.jobInfo?.billClient?.businessName || ""
                }
              />

              {/* <InfoText
                size="sm"
                title={"END CLIENT"}
                value={"ShubhaMinds, LLC"}
              /> */}
              <InfoText
                size="sm"
                title={"END CLIENT"}
                // value={"ShubhaMinds, LLC"}
                value={
                  currentPlacementData?.jobInfo?.billClient?.businessName || ""
                }
              />
              {/* <InfoText title={"JOB START DATE"} size="sm" value={"09/28/2023"} /> */}
              <InfoText
                title={"JOB START DATE"}
                size="sm"
                value={
                  dateFormator(
                    currentPlacementData?.jobInfo?.startDate,
                    "month-day-year",
                  ) || "-"
                }
              />
              {/* <InfoText title={"JOB END DATE"} size="sm" value={"01/31/2025"} /> */}
              <InfoText
                title={"JOB END DATE"}
                size="sm"
                value={
                  dateFormator(
                    currentPlacementData?.jobInfo?.endDate,
                    "month-day-year",
                  ) || "-"
                }
              />

              {/* <InfoText title={"PROJECT"} size="sm" value={"--"} /> */}
              <InfoText
                title={"Project"}
                size="sm"
                value={currentPlacementData?.clientPlacement?.project || "-"}
              />
              <InfoText
                title={"Invoice Frequency"}
                size="sm"
                value={
                  invoiceFrequencyTypeOptions?.find(
                    (item) =>
                      item?.value ===
                        currentPlacementData?.invoices?.frequency || null,
                  )?.label || "-"
                }
              />
              {/* pending */}
            </div>
            <div className="mt-4">
              <p className="mb-2">Employee Information</p>
              <Divider />
              <div className="grid grid-cols-2 gap-y-6 mt-6">
                <InfoText
                  title={"EMPLOYEE NAME"}
                  size="sm"
                  // value={"Ramesh Manthri"}
                  value={[
                    currentPlacementData?.employeeId?.firstName,
                    currentPlacementData?.employeeId?.lastName,
                  ]
                    .filter(Boolean)
                    .join(" ")}
                />

                <InfoText
                  title={"EMPLOYEE ID"}
                  size="sm"
                  // value={"CON - 2064"}
                  value={
                    (currentPlacementData?.employeeId?.uiid && employeeId) || ""
                  }
                />
                <InfoText
                  title={"EMAIL ID"}
                  size="sm"
                  // value={"rameshmanthri432@gmail.com"}
                  value={currentPlacementData?.employeeId?.email.primary || ""}
                />
                <InfoText title={"DEPARTMENT"} size="sm" value={"Consulting"} />

                <InfoText
                  title={"ROLE"}
                  size="sm"
                  value={
                    currentPlacementData?.employeeId?.employmentType
                      ? ["Regular", "Consultant", "Contractor"][
                          currentPlacementData?.employeeId?.employmentType - 1
                        ]
                      : ""
                  }
                />
                <InfoText title={"REPORTING MANAGER"} size="sm" value={"--"} />

                <InfoText
                  title={"FINANCE MANAGER"}
                  size="sm"
                  value={employeeManagers.finance || "--"}
                />
                <InfoText
                  title={"HR MANAGER"}
                  size="sm"
                  value={employeeManagers.hr || "--"}
                />
              </div>
            </div>
          </div>
        </Drawer>
      </div>
      <Backdrop isOpen={isSaving}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default SubmitTimesheet;
